const en = {    
    "Não": "No",
    "Ressecção de Tumor intracardíaco": "Resection of intracardiac tumor",
    "Transplante Cardíaco": "Heart transplant",
    "Implante de eletrodo epicárdico": "Epicardial lead implant",
    "Janela pleuropericárdica": "Pleuropericardial window",
    "Pericardiectomia": "Pericardiectomy",
    "Cox Maze": "Cox Maze",
    "Fechamento de auriculeta": "Atrial appendage closure",
    "Campos_Obrigatorios": "The following fields are required:",
    "Identificacao": "Identification",
    "Identificacao_Descricao": "Form that collects basic patient identification data",
    "PreOperatorio": "Preoperative",
    "PreOperatorio_Descricao": "Pre-surgical assessment focusing on exams and patient preparation",
    "Escores": "Scores",
    "Escores_Descricao": "Collection of clinical scores for evaluating the patient's health status",
    "Anestesia": "Anesthesia",
    "Anestesia_Descricao": "Information about the anesthetic process and patient sedation",
    "Incisao": "Incision",
    "Incisao_Descricao": "Record of the start of surgery, including details of the incision",
    "Circulacao_Extracorporea": "Extracorporeal Circulation",
    "Circulacao_Extracorporea_Descricao": "Information about the use of extracorporeal circulation during surgery",
    "Cirurgia": "Surgery",
    "Cirurgia_Descricao": "Details of the main surgical procedure performed on the patient",
    "PosOperatorio": "Postoperative",
    "PosOperatorio_Descricao": "Immediate postoperative monitoring and care",
    "Hemotransfusao": "Blood Transfusion",
    "Hemotransfusao_Descricao": "Record of blood transfusions performed during or after surgery",
    "Obito": "Death",
    "Obito_Descricao": "Record of information related to the patient's death",
    "(cm)": "(cm)",
    "(kg)": "(kg)",
    "(kg/m2)": "(kg/m2)",
    "(m2)": "(m2)",
    "FA" : "Atrial fibrillation",
    "(em uso de broncodilatador inalatório)": "(on bronchodilator therapy)",
    "(prévia à cirurgia)": "(previous to surgery)",
    "(prescrição nutricional, de exercícios ou estratégias de psicoterapia para melhorar a capacidade funcional no pré-operatório)": "(nutrition, exercise or psychological strategies that aim to enhance functional capacity before surgery)",
    "(%)": "(%)",
    "(mg/dl)": "(mg/dl)",
    "(pior dispneia ou classe funcional nas últimas 2 semanas)": "(patient's worst dyspnea or functional class in the past 2 weeks)",
    "(Classificação de angina da Canadian Cardiovascular Society)": "(Canadian Cardiovascular Society classification of angina pectoris)",
    "(%, mortalidade)": "(%, mortality)",
    "(1 ponto para cada resposta positiva: Fadigado? Não consegue subir 1 lance de escadas? Não consegue caminhar um quarteirão? Possui mais de 5 doenças? Perdeu mais de 5% do peso nos últimos 6 meses?)": "(1 point for each positive answer: Are you too tired to exercise? Can you climb one flight of stairs without assistance? Can you walk one block without assistance? Five or more illnesses? >5% weight loss over the past year?)",
    "(e.g. Morfina 10 mg e Fentanil 300 mcg)": "(e.g. Morphine 10 mg, Fentanyl 300 mcg)",
    "(beating heart surgery)": "(CPB for mechanical support only)",
    "(Marca/especificação)": "(Brand/specifications)",
    "(Fr)": "(Fr)",
    "(min)": "(min)",
    "(min, 'de pele a pele')": "(min)",
    "(qualquer lesão de pelo menos 50%)": "(any lesion of at least 50% obstruction)",
    "(mm)": "(mm)",
    "(horas)": "(hours)",
    "(dias, após a cirurgia)": "(days after surgery)",
    "ID do paciente": "Registry number",
    "ID_Paciente": "Registry number",
    "Instituicao_ID" : "Number Institution",
    "Select_Instituicao": "Select the Hospital",
    "back": "Voltar",
    "Hospital": "Hospital",
    "Institutions": "Hospital",
    "ID no hospital": "Patient's ID at Hospital",
    "Nome": "Full name",
    "CPF": "Patient's ID",
    "Idade": "Age",
    "Sexo": "Gender",
    "Altura": "Height (cm)",
    "Altura (cm)":  "Height (cm)",
    altura_cm: "Height (cm)",
    "Peso": "Weight",
    "IMC": "BMI",
    "Área de superfície corpórea": "Body Surface Area",
    "HAS": "Hypertension",
    "DM": "Diabetes",
    "DM em uso de insulina": "Diabetes on insulin",
    "DPOC": "Chronic Obstructive Pulmonary Disease",
    "IAM prévio": "Previous myocardial infarction",
    "AVE prévio": "Cerebrovascular disease",
    "Doença arterial obstrutiva periférica": "Peripheral artery disease",
    "pre_habilitacao": "Prehabilitation",
    "Esternotomia prévia": "Previous sternotomy",
    "Cirurgia cardíaca sem esternotomia prévia": "Previous cardiac surgery without sternotomy",
    "Cirurgia torácica não cardíaca prévia": "Previous non-cardiac thoracic surgery",
    "Angioplastia prévia": "Previous percutaneous coronary intervention",
    "FEVE": "Left ventricle ejection fraction",
    "Creatinina": "Creatinine",
    "NYHA": "NYHA classification",
    "CCS": "CCS classification",
    "EuroSCORE": "EuroSCORE operative mortality risk",
    "STS": "STS Operative Mortality Risk",
    "FRAIL scale": "FRAIL score",
    "Uso de intubação seletiva": "Use of selective lung ventilation",
    "Método de intubação seletiva": "Single lung ventilation method",
    "Bloqueio regional": "Regional anesthetic block",
    "Técnica de bloqueio regional": "Regional anesthetic block method",
    "Momento do bloqueio regional": "Regional anesthetic block moment",
    "Monitorização de débito minimamente invasiva": "Minimally invasive cardiac output monitoring",
    "Monitor minimamente invasivo utilizado": "Minimally invasive cardiac output monitor used",
    "Monitorização de débito invasiva": "Invasive cardiac output monitoring",
    "Monitor invasivo utilizado": "Invasive cardiac output monitor used",
    "Monitorização do Sistema Nervoso Central": "Central nervous system monitoring",
    "Tipo de monitorizacão de SNC": "Central nervous system monitor used",
    "Manutenção de ventilação durante a CEC": "Ventilation during cardiopulmonary bypass",
    "Consumo total de opioides": "Opioid total consumption",
    "Uso de dexmedetomidina": "Dexmedetomidine use",
    "Extubação em sala": "Extubation in operating room",
    "Localização": "Localization",
    "Mediana": "Median incision",
    "Tipo de esternotomia": "Sternotomy classification",
    "Lateralidade ": "Incision side",
    "Posição": "Incision position",
    "Tamanho da incisão": "Incision length",
    "Categoria do tamanho": "Incision length classification",
    "Número de incisões adicionais": "Number of additional incisions",
    "Incisão de trabalho na pele": "Workport incision at skin level",
    "Espaço intercostal aberto": "Workport incision at intercostal space level",
    "Conversão para esternotomia": "Conversion to sternotomy",
    "Motivo da conversão": "Conversion reason",
    "Estratégia de canulação": "Cannulation strategy",
    "Método de canulação periférica": "Peripheral cannulation method",
    "Assistência sem parada cardíaca": "Beating heart surgery",
    "Sítio de canulação arterial": "Arterial cannulation site",
    "Cânula arterial utilizada": "Arterial cannula used",
    "Tamanho da cânula arterial": "Arterial cannula size",
    "Estratégia de canulação venosa": "Venous cannulation strategy",
    "Cânula venosa única utilizada": "Venous cannula used",
    "Tamanho da cânula venosa única": "Venous cannula size",
    "Número de estágios da cânula única": "Stage number of venous cannula",
    "Cânula venosa superior utilizada": "Superior venous cannula used",
    "Tamanho da cânula venosa superior": "Superior venous cannula size",
    "Cânula venosa inferior utilizada": "Inferior venous cannula used",
    "Tamanho da cânula venosa inferior": "Inferior venous cannula size",
    "Laçamento das cavas": "Secured cannulae with a tourniquet",
    "Descompressão de câmaras esquerdas": "Decompression of the left heart chambers",
    "Tipo de clampeamento": "Aortic clamping method",
    "Perfusão cerebral seletiva": "Selective cerebral perfusion use",
    "Tempo de CEC": "Onpump/bypass time",
    "Tempo de anóxia/clampeamento": "Aortic cross-clamp time",
    "Tempo de perfusão cerebral seletiva": "Selective cerebral perfusion time",
    "Tempo total da cirurgia": "Total operation time",
    "Cardioplegia utilizada": "Cardioplegic solution used",
    "Necessidade de repetir cardioplegia": "Need for na additional dose of cardioplegic solution",
    "Tipo de infusão da cardioplegia": "Method of cardioplegic solution infusion",
    "Temperatura mínima em CEC (ºC)": "Minimal temperature during bypass",
    "Fluxo alvo da CEC (ml/min)": "Targeted pump flow rate during bypass",
    "Necessidade de assistência para saída de CEC": "Need for mechanical support after bypass",
    "Assistência utilizada na saída de CEC": "Used mechanical support after bypass",
    "Uso de miniCEC": "Use of miniCPB",
    "Revascularização": "Coronary artery bypass surgery",
    "Abordagem valvar": "Valvar surgery",
    "abordagem_aorta": "Aorta surgery",
    "Abordagem da Aorta": "Aorta surgery",
    "correcao_cardiopatia_congenita" : "Congenital disease correction", 
    "outros_procedimentos_cardiacos": "Other cardiac procedures",
    "Outros Procedimentos Cardíacos": "Other cardiac procedures",
    "uso_videotoracoscopia": "Use of thoracoscopic camera",
    "uso_plataforma_robotica" : "Use of robotic platform",
    "password_strength_error": "The password must be at least 8 characters long, including uppercase letters, lowercase letters, numbers, and special characters.",    
    "Street": "Street",
    "Number": "Number",
    "Complement": "Complement",
    "Neighborhood": "Neighborhood",
    "City": "City",
    "State": "State",
    "Correção de cardiopatia congênita": "Congenital disease correction",
    "Uso de videotoracoscopia": "Use of thoracoscopic camera",
    "Uso de plataforma robótica": "Use of robotic platform",
    "Plataforma robótica utilizada": "Used robotic platform",
    "Revascularização com CEC": "Use of CPB for coronary bypass",
    "Número de coronárias acometidas": "Number of coronary vessels with obstructive lesions",
    "Número de coronárias abordadas": "Number of coronary vessels receiving grafts",
    "Número de enxertos utilizados": "Number of grafts used",
    "Uso da mamária esquerda": "Use of left internal mammary artery",
    "Método de dissecção da mamária esquerda": "Method of LIMA harvesting",
    "Material utilizado na dissecção da mamária esquerda": "Instruments used for LIMA harvesting",
    "Uso da mamária direita": "Use of right internal mammary artery",
    "Método de dissecção da mamária direita": "Method of RIMA harvesting",
    "Material utilizado na dissecção da mamária direita": "Instruments used for RIMA harvesting",
    "Uso de A. radial": "Radial artery harvesting",
    "Retirada endoscópica da radial": "Endoscopic harvesting of radial artery",
    "Uso de A. gastroepiploica": "Gastroepiploic artery harvesting",
    "Uso de A. epigástrica inferior": "Inferior epigastric artery harvesting",
    "Uso de V. safena magna": "Use of saphenous vein graft",
    "Uso da técnica safena no-touch": "Use of no-touch technique for SVG",
    "Retirada endoscópica da safena": "Use of endoscopic harvesting for SVG",
    "Uso de enxertos compostos": "Use of a composite graft technique",
    "Uso de ténica em Y": "Use of Y composite graft",
    "Uso de anastomoses sequenciais": "Use of sequential composite grafting",
    "Uso de estabilizador cardíaco": "Use of cardiac stabilizer",
    "Estabilizador utilizado": "Use of cardiac stabilizer",
    "Uso de posicionador cardíaco": "Use of cardiac positioner",
    "Posicionador utilizado": "Used cardiac positioner",
    "Material utilizado na anastomose coronariana": "Instruments used during coronary anastomosis",
    "Marca do material de mini utilizado": "Brand/specifications of mini material",
    "Angioplastia programada (cirurgia híbrida)": "Programed for future PCI (hybrid procedure)",
    "Abordagem da Valva Aórtica": "Aortic valve approach",
    "Técnica de plastia valvar aórtica": "Aortic valve repair technique",
    "Insuficiência aórtica pós-CEC": "Aortic regurgitation after bypass",
    "Prótese valvar aórtica": "Prosthetic aortic valve",
    "Tamanho da prótese valvar aórtica": "Prosthetic aortic valve size",
    "Prótese de liberação rápida aórtica": "Rapid-deployment aortic valve replacement",
    "Uso de prótese aórtica endovascular": "Use of stented valve bioprosthesis for aortic position",
    "Prótese aórtica com tratamento anticalcificante": "Anticalcification treatment aortic valve bioprosthesis",
    "Especificações da prótese aórtica": "Aortic valve prosthesis specifications",
    "Leak paravalvar aórtico": "Paravalvular leak after aortic valve replacement",
    "Abordagem da Valva Mitral": "Mitral valve approach",
    "Via de acesso da valva mitral": "Route of approach to the mitral valve",
    "Plastia valvar mitral": "Mitral valve repair",
    "Troca valvar mitral": "Mitral valve replacement",
    "Comissurotomia mitral": "Mitral commissurotomy",
    "Uso de neocorda": "Neochord use",
    "Especificações da neocorda": "Neochord specifications",
    "Uso de anel mitral": "Use of mitral ring",
    "Especificações do anel mitral": "Mitral ring specifications",
    "Ressecção de folheto mitral": "Mitral leaflet resection",
    "Anuloplastia posterior mitral": "Posterior mitral annuloplasty",
    "Gradiente médio da valva mitral pós-CEC": "Mean gradient of mitral valve after bypass",
    "Insuficiência mitral pós-CEC": "Mitral regurgitation after bypass",
    "Prótese valvar mitral": "Type of mitral valve prosthesis",
    "Tamanho da prótese valvar mitral": "Size of mitral valve prosthesis",
    "Prótese de liberação rápida mitral": "Rapid-deployment mitral valve replacement",
    "Uso de prótese mitral endovascular": "Use of stented valve bioprosthesis for mitral position",
    "Prótese mitral com tratamento anticalcificante": "Anticalcification treatment mitral valve bioprosthesis",
    "Especificações da prótese mitral": "Mitral valve prosthesis specifications",
    "Leak paravalvar mitral": "Paravalvular leak after mitral valve replacement",
    "Fechamento de auriculeta esquerda": "Left atrial appendage occlusion",
    "Abordagem da Valva Pulmonar": "Pulmonary valve surgery",
    "Plastia valvar pulmonar": "Pulmonary valve repair",
    "Troca valvar pulmonar": "Pulmonary valve replacement",
    "Técnica de plastia valvar pulmonar": "Pulmonary valve repair technique",
    "Gradiente médio valvar pulmonar pós-CEC": "Mean gradient of pulmonary valve after bypass",
    "Insuficiência pulmonar pós-CEC": "Pulmonary regurgitation after bypass",
    "Prótese valvar pulmonar": "Type of pulmonary valve prosthesis",
    "Prótese de liberação rápida pulmonar": "Rapid-deployment pulmonary valve replacement",
    "Uso de prótese pulmonar endovascular": "Use of stented valve bioprosthesis for pulmonary position",
    "Prótese pulmonar com tratamento anticalcificante": "Anticalcification treatment pulmonary valve bioprosthesis",
    "Especificações da prótese pulmonar": "Pulmonary valve prosthesis specifications",
    "Leak paravalvar pulmonar": "Paravalvular leak after pulmonary valve replacement",
    "Abordagem da Valva Tricúspide": "Tricuspid valve approach",
    "Plastia valvar tricúspide": "Tricuspid valve repair",
    "Troca valvar tricúspide": "Tricuspid valve replacement",
    "Técnica de plastia valvar tricúspide": "Tricuspid valve repair technique",
    "Especificações do anel tricúspide": "Tricuspid ring specifications",
    "Gradiente médio valvar tricúspide pós-CEC": "Mean gradient of tricuspid valve after bypass",
    "Insuficiência valvar tricúspide pós-CEC": "Tricuspid regurgitation after bypass",
    "Prótese valvar tricúspide": "Type of tricuspid valve prosthesis",
    "Tamanho da prótese valvar tricúspide": "Size of tricuspid valve prosthesis",
    "Prótese de liberação rápida tricúspide": "Rapid-deployment tricuspid valve replacement",
    "Uso de prótese tricúspide endovascular": "Use of stented valve bioprosthesis for tricuspid position",
    "Prótese tricúspide com tratamento anticalcificante": "Anticalcification treatment tricuspid valve bioprosthesis",
    "Especificações da prótese tricúspide": "Tricuspid valve prosthesis specifications",
    "Leak paravalvar tricúspide": "Paravalvular leak after tricuspid valve replacement",
    "Segmentos da aorta abordados": "Segments of aorta approached",
    "Reimplante de coronárias": "Coronary reimplantation",
    "Preservação da valva aórtica nativa": "Valve-sparring procedure",
    "Uso de tubo sintético": "Use of interposition tube graft",
    "Uso de tubo valvado": "Use of composite graft (Dacron + Valve)",
    "Tipo de valva do tubo valvado": "Type of valve in the composite graft",
    "Especificações do material utilizado na Aorta": "Specifications of used material",
    "Programação de Procedimento Híbrido": "Planning for hybrid procedure",
    "Cardiopatia congênita abordada": "Type of surgery for congenital disease",
    "Uso de pericárdio": "Use of pericardial patch",
    "Uso de afastador de partes moles": "Use of soft tissue retractor",
    "Especificações do Afastador de Partes Moles": "Soft tissue retractor specifications",
    "Luxação, fratura de costelas/articulação costocondral": "Dislodgement or fracture of ribs or costochondral joint",
    "Uso de fixação rígida": "Use of rigid fixation devices",
    "Sítio da fixação rígida": "Rigid fixation site",
    "Especificações da prótese de fixação rígida": "Rigid fixation device specifications",
    "Pericardiotomia posterior esquerda": "Posterior left pericardiotomy",
    "Drenagem pericárdica": "Use of drainage chest tube in the pericardium",
    "Drenagem pleural": "Use of drainage chest tube in the pleura",
    "Tipo de dreno pleural utilizado": "Type of chest tube used",
    "Tempo de extubação após admissão na UTI": "Time to extubation",
    "Tempo de permanência em Unidade de Terapia Intensiva": "ICU lenght of stay",
    "Tempo de permanência em internação Hospitalar": "Hospital length of stay",
    "Dor pós-operatória relatada": "Postoperative pain reported",
    "Escala visual analógica da dor": "Visual analogue scale of pain",
    "Tempo para início de mobilização no leito": "Time until mobilization in bed",
    "Tempo para início de deambulação": "Time until walking",
    "Infecção": "Infection",
    "Deiscência de ferida operatória ": "Wound dehiscence",
    "Infarto do miocárdio pós-operatório": "Myocardial infarction after surgery",
    "Necessidade de nova revascularização não programada durante internação ": "Need for non-planned revascularization after surgery",
    "Derrame pleural": "Pleural effusion",
    "Tamponamento cardíaco": "Cardiac tamponade",
    "Necessidade de primeira diálise": "Dialysis",
    "AVE novo com sequela": "Postoperative stroke",
    "Fibrilação Atrial pós-operatória": "Postoperative atrial fibrillation",
    "Parada cardiorrespiratória revertida no pós-operatório": "Postoperative cardiac arrest reverted",
    "Necessidade de Dispositivo de Assistência Circulatória no pós-operatório": "Need for mechanical support after surgery",
    "Tipo de dispositivo de assistência circulatória ": "Type of mechanical support after surgery",
    "Tempo para início da retirada dos drenos (horas)": "Time until first chest tube removal",
    "Readmissão hospitalar": "Hospital readmission",
    "Transfusão de hemoderivados": "Transfusion of blood products",
    "Momento da transfusão": "Timing of transfusion",
    "Elemento transfundido": "Blood component transfused",
    "Óbito intra-hospitalar": "Death before discharge",
    "Motivo do óbito": "Cause of death",
    "Momento do óbito": "Timing of death",
    "Óbito durante seguimento": "Death during follow-up",
    "Tempo do óbito após cirurgia (dias)": "Time of death after surgery",
    "Exportacao_info_1": "Do you want to include data from other forms?",
    "Exportacao": "Export",
    "Exportar": "Export",
    "esqueceu_sua_senha": "Forgot your password?",
    "Users": "Users",
    "logout": "Logout",
    "Pacientes": "Patients",
    "Institution_Registration": "Institution Registration",
    "Institution": "Institution",
    "Name_of_Institution": "Name of Institution",
    "ZIP_Code": "Institution's ZIP Code",
    "Institution_Address": "Institution Address",
    "Institution_Telephone_Number": "Institution Telephone Number",
    "CNES": "CNES of the Institution",
    "Responsible": "Responsible",
    "date_invalid": "Invalid date. Please check the day, month, and year.",
    "day_invalid": "Invalid day for the informed month.",
    "date_future": "Date cannot be in the future.",
    "date_past": "Birthdate is too old.",
    "Name_Responsible": "Name",
    "Email_Responsible": "Email",
    "Register_Success": "Registration completed successfully",
    "Telefone_Ramal_Responsible": "Telephone",
    "Password": "Password",
    "Password_info": "Use 8 or more characters with a mix of letters, numbers, and symbols.",
    "Confirm_Password": "Confirm Password",
    "Register": "Register",
    "Already_Registered": "Already Registered?",
    "language": "Language",
    "welcome": "Welcome to Cardux MICS",
    "welcome_p2": "Please enter your login details!",
    "user": "User",
    "password": "Password",
    "remember_me": "Remember me",
    "invalid_data": "Invalid data",
    "login": "Login",
    "dashboard": "Dashboard",
    "new_patient_registration": "New Patient Registration",
    "my_patients": "My patients",
    "generate_report": "Generate Report",
    "my_summary": "My summary",
    "surgeries": "Surgeries",
    "times": "Times",
    "survival": "Survival",
    "hours": "hours",
    "days": "days",
    "in_30_days": "in 30 days",
    "IOT_h": "IOT",
    "IOT_p": "Time to extubation",
    "UTI_h": "ICU",
    "UTI_p": "ICU time",
    "LOS_h": "LOS",
    "LOS_p": "Length of hospital stay",
    "logoff": "Logoff",
    "Records": "Records",
    "no_records_found": "No records found",
    "Details": "Details",
    "Voltar": "Go back",
    "Create": "Create",
    "Update": "Update",
    "nome": "Name",
    "hospital": "Hospital",
    "Criar_Paciente": "Create Patient",
    "Categories": "Categories",
    "Form_for": "Form for",
    "Salvar": "Save",
    "identificacao": "Identification",
    "pre_operatorio": "Preoperative",
    "escores": "Scores",
    "anestesia": "Anesthesia",
    "incisao": "Incision",
    "circulacao_extracorporea": "Extracorporeal circulation",
    "cirurgia": "Surgery",
    "pos_operatorio": "Postoperative",
    "hemotransfusao": "Blood transfusion",
    "obito": "Death",
    "sim": "Yes",
    "nao": "No",
    "id_do_paciente": "Patient ID",
    "id_no_hospital": "Hospital ID",
    "cpf": "CPF",
    "idade": "Age",
    "sexo": "Sex",
    "altura_m": "Height (cm)",
    "altura": "Height",
    "peso": "Weight",
    "Os seguintes campos são obrigatórios:": "The following fields are required:",
    "peso_g": "Weight (g)",
    "data_nascimento": "Date of Birth",
    "peso_kg": "Weight (kg)",
    "imc": "BMI",
    "asc_m2": "BSA (m2)",
    "has": "Hypertension",
    "dm": "Diabetes",
    "DMid": "Diabetes on insulin",
    "dpoc": "COPD",
    "iam_previo": "Previous MI",
    "Cirurgia torácica prévia": "Previous thoracic surgery",
    "ave_previo": "Previous Stroke",
    "fa_pre_operatoria": "Preoperative AF",
    "DAOP": "Peripheral Arterial Disease",
    "pre_habilitado": "Pre-habilitated",
    "cirurgia_toracica_previa": "Previous thoracic surgery",
    "feve_porcenta": "EF (%)",
    "creatinina_mg_dl": "Creatinine (mg/dl)",
    "angioplastia_previa": "Previous angioplasty",
    "nyha": "NYHA",
    "ccs": "CCS",
    "euroscore_porcenta": "EUROscore (%)",
    "sts_score_porcenta": "STS score (%)",
    "frail_score": "Frail score",
    "uso_de_intubacao_seletiva": "Selective intubation use",
    "metodo_de_intubacao_seletiva": "Selective intubation method",
    "bloqueio_regional": "Regional block",
    "tecnica_de_bloqueio_regional": "Regional block technique",
    "momento_do_bloqueio_regional": "Time of regional block",
    "monitorizacao_de_debito_minimamente_invasiva": "Minimally invasive cardiac output monitoring",
    "monitor_minimamente_invasivo_utilizado": "Minimally invasive monitor used",
    "monitorizacao_de_debito_invasiva": "Invasive cardiac output monitoring",
    "monitor_invasivo_utilizado": "Invasive monitor used",
    "monitorizacao_de_snc": "CNS monitoring",
    "tipo_de_monitorizacao_de_snc": "Type of CNS monitoring",
    "manutencao_de_ventilacao_durante_a_cec": "Ventilation maintenance during ECC",
    "consumo_total_de_opioides": "Total opioid consumption",
    "uso_de_dexmedetomidina": "Dexmedetomidine use",
    "extubacao_em_sala": "Extubation in OR",
    "localizacao": "Location",
    "mediana": "Median",
    "tipo_de_esternotomia": "Sternotomy type",
    "lateralidade_se_nao_mediana": "Lateral (if not median)",
    "posicao_se_nao_mediana": "Position (if not median)",
    "tamanho_da_incisao_cm": "Incision size (cm)",
    "categoria_do_tamanho": "Size category",
    "numero_de_incisoes_adicionais": "Number of additional incisions",
    "incisao_de_trabalho_na_pele_nao_mediana": "Working incision on skin (non-median)",
    "espaco_intercostal_aberto_nao_mediana": "Open intercostal space (non-median)",
    "conversao_para_esternotomia": "Conversion to sternotomy",
    "motivo_da_conversao": "Reason for conversion",
    "tipo_de_canulacao": "Cannulation type",
    "metodo_de_canulacao_periferica": "Peripheral cannulation method",
    "assistencia_sem_parada_cardiaca_beating_heart": "Support without cardiac arrest (beating heart)",
    "canulacao_arterial": "Arterial cannulation",
    "canula_arterial_utilizada_marca_especificacao": "Arterial cannula used (Brand/Specification)",
    "tamanho_da_canula_arterial_fr": "Arterial cannula size (Fr)",
    "canulacao_venosa": "Venous cannulation",
    "canula_venosa_unica_utilizada_marca_especificacao": "Single venous cannula used (Brand/Specification)",
    "tamanho_da_canula_venosa_unica_fr": "Single venous cannula size (Fr)",
    "numero_de_estagios_da_canula_unica": "Number of single cannula stages",
    "canula_venosa_superior_utilizada_marca_especificacao": "Superior venous cannula used (Brand/Specification)",
    "tamanho_da_canula_venosa_superior_fr": "Superior venous cannula size (Fr)",
    "canula_venosa_inferior_utilizada_marca_especificacao": "Inferior venous cannula used (Brand/Specification)",
    "tamanho_da_canula_venosa_inferior_fr": "Inferior venous cannula size (Fr)",
    "lacamento_das_cavas": "Caval snares",
    "tipo_de_clampeamento": "Clamping type",
    "perfusao_cerebral_seletiva": "Selective cerebral perfusion",
    "tempo_de_cec_min": "ECC time (min)",
    "tempo_de_anoxia_clampeamento_min": "Anoxia/Clamping time (min)",
    "tempo_de_perfusao_cerebral_seletiva_min": "Selective cerebral perfusion time (min)",
    "tempo_total_da_cirurgia_min_de_pele_a_pele": "Total surgery time (min, skin to skin)",
    "cardioplegia_utilizada": "Cardioplegia used",
    "necessidade_de_repetir_cardioplegia": "Need to repeat cardioplegia",
    "tipo_de_infusao_da_cardioplegia": "Cardioplegia infusion type",
    "temperatura_minima_em_cec_posicaoc": "Minimum temperature in ECC (°C)",
    "fluxo_alvo_da_cec_ml_min": "ECC target flow (ml/min)",
    "necessidade_de_assistencia_para_saida_de_cec": "Need for assistance to exit ECC",
    "assistencia_utilizada_na_saida_de_cec": "Assistance used to exit ECC",
    "uso_de_minicec": "Mini-ECC use",
    "eretor_da_espinha": "Erector spinae",
    "paraesternal": "Paraesternal",
    "subcostal": "Subcostal",
    "intercostal": "Intercostal",
    "serratil_anterior": "Anterior serratus",
    "pre_incisional": "Pre-incisional",
    "pos_incisional": "Post-incisional",
    "na_uti": "In ICU",
    "bis": "BIS",
    "qnox": "QNox",
    "nirs": "NIRS",
    "doppler_transcraniano": "Transcranial Doppler",
    "saturacao_venosa_jugular": "Jugular venous saturation",
    "1posicao_eic": "1st ICS",
    "2posicao_eic": "2nd ICS",
    "3posicao_eic": "3rd ICS",
    "4posicao_eic": "4th ICS",
    "5posicao_eic": "5th ICS",
    "6posicao_eic": "6th ICS",
    "7posicao_eic": "7th ICS",
    "8posicao_eic": "8th ICS",
    "revascularizacao": "Revascularization",
    "abordagem_valvar": "Valve approach",
    "abordagem_da_aorta": "Aorta approach",
    "correcao_de_cardiopatia_congenita": "Correction of congenital heart disease",
    "uso_de_videotoracoscopia": "Video thoracoscopy use",
    "resseccao_de_tumor_intracardiaco": "Resection of intracardiac tumor",
    "transplante_cardiaco": "Heart transplant",
    "implante_de_eletrodo_epicardico": "Epicardial electrode implantation",
    "janela_pleuropericardica": "Pleuropericardial window",
    "pericardiectomia": "Pericardiectomy",
    "cox_maze": "Cox Maze",
    "fechamento_de_auriculeta": "Atrial appendage closure",
    "uso_de_plataforma_robotica": "Robotic platform use",
    "plataforma_robotica_utilizada": "Robotic platform used",
    "revascularizacao_com_cec": "Revascularization with ECC",
    "numero_de_coronarias_acometidas": "Number of affected coronary arteries",
    "numero_de_coronarias_abordadas": "Number of addressed coronary arteries",
    "numero_de_enxertos_utilizados": "Number of grafts used",
    "uso_de_atie": "Use of LITA",
    "metodo_de_disseccao_da_atie": "LITA dissection method",
    "material_utilizado_na_disseccao_da_atie": "Material used in LITA dissection",
    "uso_de_atid": "Use of RITA",
    "pinca_de_coronaria_convencional": "Conventional coronary clamp",
    "pinca_de_mini": "Mini coronary clamp",
    "tesoura_de_potts_dietrich_convencional": "Conventional Potts/Dietrich scissors",
    "tesoura_de_mini": "Mini scissors",
    "bisturi_eletrico_monopolar_convencional": "Conventional monopolar electric scalpel",
    "bisturi_eletrico_com_extensor_de_lamina": "Electric scalpel with blade extender",
    "bisturi_harmonico": "Harmonic scalpel",
    "bisturi_eletrico_bipolar": "Bipolar electric scalpel",
    "bisturi_de_video_hook": "Video Hook scalpel",
    "bisturi_ligasure": "Ligasure scalpel",
    "plataforma_robotica": "Robotic platform",
    "metodo_de_disseccao_da_atid": "RITA dissection method",
    "material_utilizado_na_disseccao_da_atid": "Material used in RITA dissection",
    "retirada_endoscopica_da_radial": "Endoscopic radial artery removal",
    "uso_de_a_radial": "Use of radial artery",
    "uso_de_a_epigastrica_inferior": "Use of inferior epigastric artery",
    "uso_de_a_gastroepiploica": "Use of gastroepiploic artery",
    "uso_de_v_safena_magna": "Use of great saphenous vein",
    "uso_da_tecnica_safena_no_touch": "No-touch saphenous vein technique",
    "retirada_endoscopica_da_safena": "Endoscopic saphenous vein removal",
    "uso_de_enxertos_compostos": "Use of composite grafts",
    "uso_de_tenica_em_y": "Use of Y technique",
    "uso_de_anastomoses_sequenciais": "Use of sequential anastomoses",
    "uso_de_estabilizador_cardiaco": "Use of cardiac stabilizer",
    "estabilizador_utilizado": "Stabilizer used",
    "uso_de_posicionador_cardiaco": "Use of cardiac positioner",
    "posicionador_utilizado": "Positioner used",
    "material_utilizado_na_anastomose_coronariana": "Material used in coronary anastomosis",
    "marca_do_material_de_mini_utilizado": "Brand of mini material used",
    "castroviejo_mini": "Mini Castroviejo",
    "castroviejo_convencional": "Conventional Castroviejo",
    "pinca_robotica": "Robotic clamp",
    "porta_agulhas_robotica": "Robotic needle holder",
    "angioplastia_programada_cirurgia_hibrida": "Planned angioplasty (hybrid surgery)",
    "abordagem_da_valva_aortica": "Aortic valve approach",
    "plastia_valvar_aortica": "Aortic valve repair",
    "troca_valvar_aortica": "Aortic valve replacement",
    "tecnica_de_plastia_valvar_aortica": "Aortic valve repair technique",
    "gradiente_medio_valvar_aortico_pos_cec": "Post-ECC mean aortic valve gradient",
    "insuficiencia_aortica_pos_cec": "Post-ECC aortic insufficiency",
    "protese_valvar_aortica": "Aortic valve prosthesis",
    "tamanho_da_protese_valvar_aortica": "Aortic valve prosthesis size",
    "protese_de_liberacao_rapida_aortica": "Rapid-release aortic prosthesis",
    "uso_de_protese_aortica_endovascular": "Use of endovascular aortic prosthesis",
    "protese_aortica_com_tratamento_anticalcificante": "Aortic prosthesis with anti-calcification treatment",
    "especificacoes_da_protese_aortica": "Aortic prosthesis specifications",
    "leak_paravalvar_aortico": "Aortic paravalvular leak",
    "abordagem_da_valva_mitral": "Mitral valve approach",
    "via_de_acesso_da_valva_mitral": "Mitral valve access route",
    "plastia_valvar_mitral": "Mitral valve repair",
    "troca_valvar_mitral": "Mitral valve replacement",
    "comissurotomia_mitral": "Mitral commissurotomy",
    "uso_de_neocorda": "Use of neocord",
    "especificacoes_da_neocorda": "Neocord specifications",
    "uso_de_anel_mitral": "Mitral ring use",
    "especificacoes_do_anel_mitral": "Mitral ring specifications",
    "resseccao_de_folheto_mitral": "Mitral leaflet resection",
    "anuloplastia_posterior_mitral": "Mitral posterior annuloplasty",
    "gradiente_medio_da_valva_mitral_pos_cec": "Post-ECC mean mitral valve gradient",
    "insuficiencia_mitral_pos_cec": "Post-ECC mitral insufficiency",
    "protese_valvar_mitral": "Mitral valve prosthesis",
    "tamanho_da_protese_valvar_mitral": "Mitral valve prosthesis size",
    "protese_de_liberacao_rapida_mitral": "Rapid-release mitral prosthesis",
    "uso_de_protese_mitral_endovascular": "Use of endovascular mitral prosthesis",
    "protese_mitral_com_tratamento_anticalcificante": "Mitral prosthesis with anti-calcification treatment",
    "especificacoes_da_protese_mitral": "Mitral prosthesis specifications",
    "leak_paravalvar_mitral": "Mitral paravalvular leak",
    "fechamento_de_auriculeta_esquerda": "Left atrial appendage closure",
    "abordagem_da_valva_pulmonar": "Pulmonary valve approach",
    "plastia_valvar_pulmonar": "Pulmonary valve repair",
    "troca_valvar_pulmonar": "Pulmonary valve replacement",
    "tecnica_de_plastia_valvar_pulmonar": "Pulmonary valve repair technique",
    "gradiente_medio_valvar_pulmonar_pos_cec": "Post-ECC mean pulmonary valve gradient",
    "insuficiencia_pulmonar_pos_cec": "Post-ECC pulmonary insufficiency",
    "protese_valvar_pulmonar": "Pulmonary valve prosthesis",
    "tamanho_da_protese_valvar_pulmonar": "Pulmonary valve prosthesis size",
    "protese_de_liberacao_rapida_pulmonar": "Rapid-release pulmonary prosthesis",
    "uso_de_protese_pulmonar_endovascular": "Use of endovascular pulmonary prosthesis",
    "protese_pulmonar_com_tratamento_anticalcificante": "Pulmonary prosthesis with anti-calcification treatment",
    "especificacoes_da_protese_pulmonar": "Pulmonary prosthesis specifications",
    "leak_paravalvar_pumonar": "Pulmonary paravalvular leak",
    "abordagem_da_valva_tricuspide": "Tricuspid valve approach",
    "plastia_valvar_tricuspide": "Tricuspid valve repair",
    "troca_valvar_tricuspide": "Tricuspid valve replacement",
    "tecnica_de_plastia_valvar_tricuspide": "Tricuspid valve repair technique",
    "especificacoes_do_anel_tricuspide": "Tricuspid ring specifications",
    "gradiente_medio_valvar_tricuspide_pos_cec": "Post-ECC mean tricuspid valve gradient",
    "insuficiencia_valvar_tricuspide_pos_cec": "Post-ECC tricuspid insufficiency",
    "protese_valvar_tricuspide": "Tricuspid valve prosthesis",
    "tamanho_da_protese_valvar_tricuspide": "Tricuspid valve prosthesis size",
    "protese_de_liberacao_rapida_tricuspide": "Rapid-release tricuspid prosthesis",
    "uso_de_protese_tricuspide_endovascular": "Use of endovascular tricuspid prosthesis",
    "protese_tricuspide_com_tratamento_anticalcificante": "Tricuspid prosthesis with anti-calcification treatment",
    "especificacoes_da_protese_tricuspide": "Tricuspid prosthesis specifications",
    "leak_paravalvar_tricuspide": "Tricuspid paravalvular leak",
    "segmentos_da_aorta_abordados": "Aortic segments addressed",
    "reimplante_de_coronarias": "Coronary reimplantation",
    "preservacao_da_valva_aortica_nativa": "Preservation of native aortic valve",
    "uso_de_tubo_sintetico": "Use of synthetic tube",
    "tamanho_do_tubo_sintetico_mm": "Synthetic tube size (mm)",
    "uso_de_tubo_valvado": "Use of valved tube",
    "tipo_de_valva_do_tubo_valvado": "Valve type of the valved tube",
    "especificacoes_do_material_utilizado_na_aorta": "Specifications of material used in the aorta",
    "programacao_de_procedimento_hibrido": "Hybrid procedure planning",
    "cardiopatia_congenita_abordada": "Congenital heart disease addressed",
    "uso_de_pericardio": "Use of pericardium",
    "uso_de_afastador_de_partes_moles": "Use of soft tissue retractor",
    "especificacoes_do_afastador_de_partes_moles": "Soft tissue retractor specifications",
    "uso_de_fixacao_rigida": "Use of rigid fixation",
    "sitio_da_fixacao_rigida": "Rigid fixation site",
    "especificacoes_da_protese_de_fixacao_rigida": "Rigid fixation prosthesis specifications",
    "pericardiotomia_posterior_esquerda": "Left posterior pericardiotomy",
    "drenagem_pericardica": "Pericardial drainage",
    "drenagem_pleural": "Pleural drainage",
    "tipo_de_dreno_pleural_utilizado": "Type of pleural drain used",
    "tempo_de_permanencia_em_unidade_de_terapia_intensiva_horas": "ICU stay duration (hours)",
    "tempo_de_permanencia_em_internacao_hospitalar_dias": "Hospital stay duration (days)",
    "tempo_de_extubacao_apos_admissao_na_uti_horas": "Extubation time after ICU admission (hours)",
    "dor_pos_operatoria": "Postoperative pain",
    "escala_visual_analogica_da_dor": "Visual Analog Scale for pain",
    "tempo_para_inicio_de_mobilizacao_no_leito_horas": "Time to begin in-bed mobilization (hours)",
    "tempo_para_inicio_de_deambulacao_horas": "Time to begin walking (hours)",
    "infeccao": "Infection",
    "deiscencia_de_ferida_operatoria_": "Operative wound dehiscence",
    "infarto_do_miocardio_pos_operatorio": "Postoperative myocardial infarction",
    "necessidade_de_nova_revascularizacao_nao_programada_durante_internacao_": "Unplanned revascularization during hospitalization",
    "necessidade_de_primeira_dialise": "Need for first dialysis",
    "ave_novo_com_sequela": "New stroke with sequela",
    "fibrilacao_atrial_pos_operatoria": "Postoperative atrial fibrillation",
    "parada_cardiorrespiratoria_revertida_no_pos_operatorio": "Postoperative cardiorespiratory arrest with recovery",
    "necessidade_de_dispositivo_de_assistencia_circulatoria_no_pos_operatorio": "Need for circulatory assist device postoperatively",
    "tipo_de_dispositivo_de_assistencia_circulatoria_": "Type of circulatory assist device",
    "tempo_para_inicio_da_retirada_dos_drenos_horas": "Time to begin drain removal (hours)",
    "transfusao_de_hemoderivados": "Blood product transfusion",
    "momento_da_transfusao": "Time of transfusion",
    "elemento_transfundido": "Transfused element",
    "obito_intra_hospitalar": "In-hospital death",
    "motivo_do_obito": "Cause of death",
    "momento_do_obito": "Time of death",
    "obito_durante_seguimento": "Death during follow-up",
    "tempo_do_obito_apos_cirurgia_dias": "Time of death after surgery (days)",
    "Confirmar_salvar": "Would you like to confirm your change?",
    "Confirmar": "Confirm",
    "Yes": "Yes",
    "No": "No",
    "Operacao_cancelada": "Operation canceled",
    "Edit_Anestesia": "Edit anesthesia",
    "Add_Anestesia": "Add anesthesia",
    "Robertshaw": "Robertshaw",
    "Sonda de oclusão brônquica": "Bronchial occlusion tube",
    "Eretor da espinha": "Erector spinae",
    "Paraesternal": "Paraesternal",
    "Subcostal": "Subcostal",
    "Intercostal": "Intercostal",
    "Serrátil anterior": "Anterior serratus",
    "Pré-incisional": "Pre-incisional",
    "Pós-incisional": "Post-incisional",
    "Na UTI": "In the ICU",
    "FloTrac/Vigileo": "FloTrac/Vigileo",
    "PICCO": "PICCO",
    "LidCO": "LidCO",
    "Swan-Ganz": "Swan-Ganz",
    "Termodiluição transpulmonar": "Transpulmonary thermodilution",
    "Monitorização de SNC": "CNS monitoring",
    "Tipo de monitorização de SNC": "CNS monitoring type",
    "BIS": "BIS",
    "QNox": "QNox",
    "NIRS": "NIRS",
    "Doppler transcraniano": "Transcranial Doppler",
    "Saturação venosa jugular": "Jugular venous saturation",
    "Selecione": "Select",
    "Sim": "Yes",
    "Edit_PreOperatorio": "Edit Preoperative",
    "Add_PreOperatorio": "Add Preoperative",
    "Select_Sexo": "Select Gender",
    "Masculino": "Male",
    "Feminino": "Female",
    "ASC": "ASC",
    "Edit_Escore": "Editar Escore",
    "Add_Escore": "Agregar Escore",
    "EUROscore (%)": "EUROscore (%)",
    "STS score (%)": "STS score (%)",
    "Frail score": "Frail score",
    "euroscore": "EUROscore",
    "sts_score": "STS score",
    "uso_intubacao_seletiva": "Use of selective intubation",
    "monitorizacao_debito_min_invasiva": "Minimally invasive hemodynamic monitoring",
    "monitorizacao_debito_invasiva": "Invasive hemodynamic monitoring",
    "monitorizacao_snc": "CNS monitoring",
    "manutencao_ventilacao_cec": "Ventilation maintenance during CPB",
    "consumo_total_opioides": "Total opioid consumption",
    "uso_dexmedetomidina": "Use of dexmedetomidine",
    "Edit_Incisao": "Edit Incision",
    "Add_Incisao": "Add Incision",
    "Lateralidade": "Laterality",
    "Endoscópica <= 2cm": "Endoscopic <= 2cm",
    "Microincisão 2-4cm": "Micro-incision 2-4cm",
    "Miniincisão 4-6cm": "Mini-incision 4-6cm",
    "Convencional >= 6cm": "Conventional >= 6cm",
    "tamanho_incisao": "Incision size",
    "conversao_esternotomia": "Conversion to sternotomy",
    "Esternotomia": "Sternotomy",
    "Miniesternotomia em J": "J-shaped mini-sternotomy",
    "Miniesternotomia em L": "L-shaped mini-sternotomy",
    "Toracotomia anterior direita": "Right anterior thoracotomy",
    "Toracotomia axilar direita": "Right axillary thoracotomy",
    "Toracotomia periareolar direita / MAMICS": "Right periareolar thoracotomy / MAMICS",
    "Toracotomia anterolateral esquerda": "Left anterolateral thoracotomy",
    "Toracotomia lateral esquerda": "Left lateral thoracotomy",
    "Sem esternotomia": "No sternotomy",
    "Completa/Convencional": "Complete/Conventional",
    "Parcial em J": "Partial in J",
    "Parcial em L": "Partial in L",
    "Parcial em T invertido": "Partial in inverted T",
    "Parcial em T": "Partial in T",
    "H deitado": "Horizontal H",
    "Esquerda": "Left",
    "Direita": "Right",
    "Anterior": "Anterior",
    "Anterolateral": "Anterolateral",
    "Lateral/Axilar": "Lateral/Axillary",
    "1º EIC": "1st ICS",
    "2º EIC": "2nd ICS",
    "3º EIC": "3rd ICS",
    "4º EIC": "4th ICS",
    "5º EIC": "5th ICS",
    "6º EIC": "6th ICS",
    "7º EIC": "7th ICS",
    "8º EIC": "8th ICS",
    "Tipo de canulação": "Cannulation type",
    "Sem canulação": "No cannulation",
    "Periférica": "Peripheral",
    "Central": "Central",
    "Mista": "Mixed",
    "Sem clampeamento": "No clamping",
    "Convencional": "Conventional",
    "Endoclamp": "Endoclamp",
    "Chitwood": "Chitwood",
    "Punção": "Puncture",
    "Dissecção": "Dissection",
    "Punção por visão direta": "Direct vision puncture",
    "Canulação arterial": "Arterial cannulation",
    "Aorta ascendente": "Ascending aorta",
    "Arco aórtico": "Aortic arch",
    "Tronco braquiocefálico": "Brachiocephalic trunk",
    "Axilar": "Axillary",
    "Subclávia": "Subclavian",
    "Carotídea": "Carotid",
    "Femoral": "Femoral",
    "Ilíaca externa": "External iliac",
    "Estágio único": "Single stage",
    "Duplo estágio": "Double stage",
    "Triplo estágio": "Triple stage",
    "Multiperfurada": "Multiperforated",
    "Balão intra-aórtico": "Intra-aortic balloon",
    "Centrimag": "Centrimag",
    "ECMO VA": "ECMO VA",
    "ECMO VV": "ECMO VV",
    "Berlin Heart": "Berlin Heart",
    "HeartMate": "HeartMate",
    "Edit_CirculacaoExtracorporea": "Edit Extracorporeal Circulation",
    "Add_CirculacaoExtracorporea": "Add Extracorporeal Circulation",
    "Canulação venosa": "Venous cannulation",
    "Atrial única": "Single atrial",
    "Bicaval": "Bicaval",
    "Femoral única": "Single femoral",
    "Jugular única": "Single jugular",
    "Jugular + femoral": "Jugular + femoral",
    "Cava superior + femoral": "Superior vena cava + femoral",
    "Bicaval + cava esquerda": "Bicaval + left cava",
    "Outra": "Other",
    "multiperfurada": "Multi-perforated",
    "Cirurgia em assistência": "Assisted surgery",
    "Del Nido": "Del Nido",
    "Custodiol": "Custodiol",
    "Anterógrada": "Antegrade",
    "Retrógrada": "Retrograde",
    "Combinada": "Combined",
    "Abordagem Valvar": "Valve Approach",
    "Correção de Cardiopatia Congênita": "Congenital Heart Disease Correction",
    "Uso de Videotoracoscopia": "Use of Videothoracoscopy",
    "Uso de Plataforma Robótica": "Use of Robotic Platform",
    "Uso de Afastador de Partes Moles": "Use of Soft Tissue Retractor",
    "Uso de Fixação Rígida": "Use of Rigid Fixation",
    "Sítio da Fixação Rígida": "Site of Rigid Fixation",
    "Especificações da Prótese de Fixação Rígida": "Specifications of Rigid Fixation Prosthesis",
    "Pericardiotomia Posterior Esquerda": "Left Posterior Pericardiotomy",
    "Drenagem Pericárdica": "Pericardial Drainage",
    "Drenagem Pleural": "Pleural Drainage",
    "Tipo de Dreno Pleural Utilizado": "Type of Pleural Drain Used",
    "Plataforma Robótica Utilizada": "Robotic Platform Used",
    "Número de Coronárias Acometidas": "Number of Affected Coronary Arteries",
    "Número de Coronárias Abordadas": "Number of Approached Coronary Arteries",
    "Número de Enxertos Utilizados": "Number of Grafts Used",
    "Uso de ATIE": "Use of ITA (Internal Thoracic Artery)",
    "Método de Dissecção da ATIE": "ITA Dissection Method",
    "Material Utilizado na Dissecção da ATIE": "Material Used in ITA Dissection",
    "Uso de ATID": "Use of Inferior Thoracic Artery",
    "Método de Dissecção da ATID": "Inferior Thoracic Artery Dissection Method",
    "Material Utilizado na Dissecção da ATID": "Material Used in Inferior Thoracic Artery Dissection",
    "Uso de A. Radial": "Use of Radial Artery",
    "Uso de A. Gastroepiploica": "Use of Gastroepiploic Artery",
    "Uso de A. Epigástrica Inferior": "Use of Inferior Epigastric Artery",
    "Uso de V. Safena Magna": "Use of Great Saphenous Vein",
    "Uso de Estabilizador Cardíaco": "Use of Cardiac Stabilizer",
    "Uso de Posicionador Cardíaco": "Use of Cardiac Positioner",
    "Material Utilizado na Anastomose Coronariana": "Material Used in Coronary Anastomosis",
    "Marca do Material de Mini Utilizado": "Brand of Mini Instruments Used",
    "Angioplastia Programada (Cirurgia Híbrida)": "Scheduled Angioplasty (Hybrid Surgery)",
    "Segmentos da Aorta Abordados": "Segments of the Aorta Addressed",
    "Uso de Tubo Sintético": "Use of Synthetic Tube",
    "Especificações do Material Utilizado na Aorta": "Specifications of Material Used in Aorta",
    "Cardiopatia Congênita Abordada": "Congenital Heart Disease Addressed",
    "Uso de Pericárdio": "Use of Pericardium",
    "Retirada Endoscópica da Radial": "Endoscopic Removal of Radial Artery",
    "Uso da Técnica Safena No-Touch": "Use of No-Touch Saphenous Technique",
    "Retirada Endoscópica da Safena": "Endoscopic Removal of Saphenous Vein",
    "Uso de Enxertos Compostos": "Use of Composite Grafts",
    "Estabilizador Utilizado": "Stabilizer Used",
    "Posicionador Utilizado": "Positioner Used",
    "Plastia Valvar Aórtica": "Aortic Valve Repair",
    "Troca Valvar Aórtica": "Aortic Valve Replacement",
    "Via de Acesso da Valva Mitral": "Mitral Valve Access Route",
    "Plastia Valvar Mitral": "Mitral Valve Repair",
    "Troca Valvar Mitral": "Mitral Valve Replacement",
    "Fechamento de Auriculeta Esquerda": "Left Atrial Appendage Closure",
    "Plastia Valvar Pulmonar": "Pulmonary Valve Repair",
    "Troca Valvar Pulmonar": "Pulmonary Valve Replacement",
    "Plastia Valvar Tricúspide": "Tricuspid Valve Repair",
    "Troca Valvar Tricúspide": "Tricuspid Valve Replacement",
    "Reimplante de Coronárias": "Coronary Reimplantation",
    "Preservação da Valva Aórtica Nativa": "Preservation of Native Aortic Valve",
    "Tamanho do Tubo Sintético": "Size of Synthetic Tube",
    "Uso de Tubo Valvado": "Use of Valved Tube",
    "Uso de Técnica em Y": "Use of Y Technique",
    "Uso de Anastomoses Sequenciais": "Use of Sequential Anastomoses",
    "Técnica de Plastia Valvar Aórtica": "Aortic Valve Repair Technique",
    "Gradiente Médio Valvar Aórtico Pós-CEC": "Mean Aortic Valve Gradient Post-ECC",
    "Insuficiência Aórtica Pós-CEC": "Aortic Insufficiency Post-ECC",
    "Prótese Valvar Aórtica": "Aortic Valve Prosthesis",
    "Tamanho da Prótese Valvar Aórtica": "Size of Aortic Valve Prosthesis",
    "Prótese de Liberação Rápida Aórtica": "Quick-Release Aortic Prosthesis",
    "Especificações da Prótese Aórtica": "Aortic Prosthesis Specifications",
    "Leak Paravalvar Aórtico": "Aortic Paravalvular Leak",
    "Comissurotomia Mitral": "Mitral Commissurotomy",
    "Uso de Neocorda": "Use of Neochord",
    "Uso de Anel Mitral": "Use of Mitral Ring",
    "Ressecção de Folheto Mitral": "Mitral Leaflet Resection",
    "Anuloplastia Posterior Mitral": "Posterior Mitral Annuloplasty",
    "Gradiente Médio Valva Mitral Pós-CEC": "Mean Mitral Valve Gradient Post-ECC",
    "Insuficiência Mitral Pós-CEC": "Mitral Insufficiency Post-ECC",
    "Prótese Valvar Mitral": "Mitral Valve Prosthesis",
    "Tamanho da Prótese Valvar Mitral": "Size of Mitral Valve Prosthesis",
    "Prótese de Liberação Rápida Mitral": "Quick-Release Mitral Prosthesis",
    "Especificações da Prótese Mitral": "Mitral Prosthesis Specifications",
    "Leak Paravalvar Mitral": "Mitral Paravalvular Leak",
    "Técnica de Plastia Valvar Pulmonar": "Pulmonary Valve Repair Technique",
    "Gradiente Médio Valvar Pulmonar Pós-CEC": "Mean Pulmonary Valve Gradient Post-ECC",
    "Insuficiência Pulmonar Pós-CEC": "Pulmonary Insufficiency Post-ECC",
    "Prótese Valvar Pulmonar": "Pulmonary Valve Prosthesis",
    "Tamanho da Prótese Valvar Pulmonar": "Size of Pulmonary Valve Prosthesis",
    "Prótese de Liberação Rápida Pulmonar": "Quick-Release Pulmonary Prosthesis",
    "Uso de Prótese Pulmonar Endovascular": "Use of Endovascular Pulmonary Prosthesis",
    "Prótese Pulmonar com Tratamento Anticalcificante": "Pulmonary Prosthesis with Anticalcification Treatment",
    "Especificações da Prótese Pulmonar": "Pulmonary Prosthesis Specifications",
    "Leak Paravalvar Pulmonar": "Pulmonary Paravalvular Leak",
    "Técnica de Plastia Valvar Tricúspide": "Tricuspid Valve Repair Technique",
    "Gradiente Médio Valvar Tricúspide Pós-CEC": "Mean Tricuspid Valve Gradient Post-ECC",
    "Insuficiência Valvar Tricúspide Pós-CEC": "Tricuspid Insufficiency Post-ECC",
    "Prótese Valvar Tricúspide": "Tricuspid Valve Prosthesis",
    "Tamanho da Prótese Valvar Tricúspide": "Size of Tricuspid Valve Prosthesis",
    "Prótese de Liberação Rápida Tricúspide": "Quick-Release Tricuspid Prosthesis",
    "Uso de Prótese Tricúspide Endovascular": "Use of Endovascular Tricuspid Prosthesis",
    "Prótese Tricúspide com Tratamento Anticalcificante": "Tricuspid Prosthesis with Anticalcification Treatment",
    "Especificações da Prótese Tricúspide": "Tricuspid Prosthesis Specifications",
    "Leak Paravalvar Tricúspide": "Tricuspid Paravalvular Leak",
    "Uso de Anel Tricuspide": "Use of Tricuspid Ring",
    "Especificações do Anel Tricúspide": "Tricuspid Ring Specifications",
    "Tipo de Valva do Tubo Valvado": "Type of Valve in Valved Tube",
    "Uso de Prótese Aórtica Endovascular": "Use of Endovascular Aortic Prosthesis",
    "Prótese Aórtica com Tratamento Anticalcificante": "Aortic Prosthesis with Anticalcification Treatment",
    "Especificações da Neocorda": "Neochord Specifications",
    "Especificações do Anel Mitral": "Mitral Ring Specifications",
    "Edit_Cirurgia": "Edit Surgery",
    "Add_Cirurgia": "Add Surgery",
    "Strattner Intuitive": "Strattner Intuitive",
    "Hugo": "Hugo",
    "Visão direta": "Direct vision",
    "Vídeo-assistida": "Video-assisted",
    "Endoscópica": "Endoscopic",
    "Robótica por esternotomia": "Robotic via sternotomy",
    "Robótica por toracotomia lateral": "Robotic via lateral thoracotomy",
    "Robótica endoscópica": "Robotic endoscopic",
    "Pinça de coronária convencional": "Conventional coronary forceps",
    "Pinça de mini": "Mini forceps",
    "Pinça robótica": "Robotic forceps",
    "Porta-agulhas robótico": "Robotic needle holder",
    "Tesoura robótica": "Robotic scissors",
    "Tesoura de Potts/Dietrich convencional": "Conventional Potts/Dietrich scissors",
    "Tesoura de mini": "Mini scissors",
    "Bisturi elétrico monopolar convencional": "Conventional monopolar electric scalpel",
    "Bisturi elétrico com extensor de lâmina": "Electric scalpel with blade extender",
    "Bisturi harmônico": "Harmonic scalpel",
    "Bisturi elétrico bipolar": "Bipolar electric scalpel",
    "Bisturi de vídeo Hook": "Hook video scalpel",
    "Bisturi Ligasure": "Ligasure scalpel",
    "Plataforma robótica": "Robotic platform",
    "Medtronic Octopus": "Medtronic Octopus",
    "Medtronic Octopus Nuvo": "Medtronic Octopus Nuvo",
    "Getinge": "Getinge",
    "Medtronic Starfish": "Medtronic Starfish",
    "Getinge Acrobat": "Getinge Acrobat",
    "(mmHg)": "(mmHg)",
    "Comissurotomia": "Commissurotomy",
    "Suspensão de postes comissurais": "Suspension of commissural posts",
    "Plicatura valvar": "Valve plication",
    "Ampliação de folheto": "Leaflet enlargement",
    "Anuloplastia": "Annuloplasty",
    "Sem leak": "No leak",
    "Mínimo": "Minimal",
    "Discreto": "Discreet",
    "Moderado": "Moderate",
    "Importante": "Significant",
    "Não aferida": "Not measured",
    "Não aferido": "Not assessed",
    "Sem insuficiência": "No insufficiency",
    "Mínima": "Minimal",
    "Discreta": "Mild",
    "Moderada": "Moderate",
    "Prótese biológica": "Biological prosthesis",
    "Prótese mecânica": "Mechanical prosthesis",
    "Homoenxerto": "Homograft",
    "Anuloplastia a DeVega": "DeVega annuloplasty",
    "Implante de neocorda": "Neochord implantation",
    "Desinserção e reinserção tricúspide": "Tricuspid detachment and reinsertion",
    "Papilarotomia": "Papillotomy",
    "Encurtamento de cordas tendíneas": "Tendon shortening",
    "Bicuspidização": "Bicuspidization",
    "Massiva": "Massive",
    "Torrencial": "Torrential",
    "Atriotomia esquerda": "Left atriotomy",
    "Transeptal": "Transseptal",
    "Exturbação em sala": "Extubation in the operating room",
    "Dor pós-operatória": "Postoperative pain",
    "Escala visual analógica da dor (0-10)": "Visual analog pain scale (0-10)",
    "Ferida operatória": "Surgical wound",
    "Outro sítio": "Other site",
    "Deiscência de ferida operatória": "Surgical wound dehiscence",
    "Esternal": "Sternal",
    "Inguinal": "Inguinal",
    "Periareolar": "Periareolar",
    "Necessidade de nova revascularização não programada": "Need for unscheduled new revascularization",
    "Necessidade de Dispositivo de Assistência Circulatória": "Need for Circulatory Assistance Device",
    "Tipo de dispositivo de assistência circulatória": "Type of circulatory assistance device",
    "Edit_PosOperatorio": "Edit Post-Operative",
    "Add_PosOperatorio": "Add Post-Operative",
    "Intra-operatório": "Intraoperative",
    "Pós-operatório": "Postoperative",
    "Hemácias": "Red blood cells",
    "Plaquetas": "Platelets",
    "Plasma Fresco Congelado": "Fresh Frozen Plasma",
    "Crioprecipitado": "Cryoprecipitate",
    "Fibrinogênio": "Fibrinogen",
    "Complexo protrombínico": "Prothrombin complex",
    "Edit_Hemotransfusao": "Edit Hemotransfusion",
    "Add_Hemotransfusao": "Add Hemotransfusion",
    "Edit_Obito": "Edit Death",
    "Add_Obito": "Add Death",
    "Momento do óbito (Intra-operatório, UTI, Enfermaria)": "Time of death (Intra-operative, ICU, Ward)",
    "Tempo do óbito após cirurgia (days)": "Time of death after surgery (days)",
    "ConfirmAction": "Are you sure you want to",
    "Activate": "activate",
    "Delete": "delete",
    "User": "the user",
    "Confirmation": "Confirmation",
    "Institutions_Management": "Hospital Management",
    "ConfirmPassword": "Confirm Password",
    "Cancel": "Cancel",
    "UserSavedSuccessfully": "User saved successfully",
    "UserManagement": "User Management",
    "NewUser": "New User",
    "ID": "ID",
    "Name": "Name",
    "Email": "Email",
    "Deleted": "Deleted?",
    "Actions": "Actions",
    "EditUser": "Edit User",
    "Endereço": "Address",
    "Ações": "Actions",
    "Editar Instituição": "Edit Hospital",
    "Nova Instituição": "New Hospital",
    "Telefone": "Phone",
    "CEP": "ZIP Code",
    "Meu_Perfil": "My Profile"
  };
  
  export default en;
